import React, {Component} from 'react'
import ReactTooltip from "react-tooltip"

let moment
const momentPromise = import(/* webpackChunkName: "momentTimezone" */ "moment-timezone")

export class DateWithIconColumnRenderer extends Component {
  constructor(props) {
    super(props)
    const stateValue = props.value || ''
    this.state = {
      relativeDate: stateValue.relativeDate,
      pickupTz: props.data.pickupTz,
      relativeDateName: stateValue.relativeDateName
    }
    this.imgRef = React.createRef()
    this.waitForImports()
  }

  async waitForImports() {
    moment = (await momentPromise).default
    this.setState({loaded: true})
  }

  handleHover() {
    ReactTooltip.rebuild()
    ReactTooltip.show(this.imgRef.current)
  }

  handleHoverOut() {
    ReactTooltip.hide(this.imgRef.current)
  }

  displayTooltipText() {
    if (this.state.relativeDateName === 'Last Free Date') {
      return (
          "<div style='font-size: 12px'>" +
          this.state.relativeDateName + " is past. Container<br/>may be subjected to more charges." +
          "</div>"
      )
    }
    return (
        "<div style='font-size: 12px'>" +
        this.state.relativeDateName + " is past <br/>and needs to be updated" +
        "</div>"
    )
  }

  render() {
    if (!moment) {
      return null
    }
    const now = moment().tz(this.state.pickupTz)
    // need to add 24 hours to the pickup date since customer has until the end of the day to pickup
    const pickupDate = moment(this.state.relativeDate, 'MM/DD/YYYY hh:mm').add(1, 'd')
    const pastRelativeDate = now.isAfter(pickupDate)
    let showWarningIcon = (!!this.state.relativeDate && pastRelativeDate)

    if (this.state.relativeDateName === 'Last Free Date') {
      showWarningIcon = showWarningIcon &&
          !['Out for Delivery', 'Empty Returned'].includes(this.props.data.cntrStatus)
    }

    return (
        <div style={{display: 'flex'}}>
          {showWarningIcon && <img data-tip={this.displayTooltipText()} data-html={true}
                                   data-for="n2c3-tooltip" ref={this.imgRef} data-place={"top"}
                                   onMouseOver={this.handleHover.bind(this)}
                                   onMouseOut={this.handleHoverOut.bind(this)}
                                   style={{position: 'absolute', zIndex: 3, left: 0, top: 11}} alt="warning"
                                   src="images/to-do-list-warning.svg"/>}
          <div>{this.state.relativeDate}</div>
        </div>
    )
  }
}

export default DateWithIconColumnRenderer